/**
 * author: 胡枭
 * desc：采购需求管理的数据字典
 */

import Dict from '@/utils/dict-utils'
// 用于与线上问卷调查字典，进行字段控制
import { projectTypeDict } from '@/dictionary/project/common'

// 成果文件类型
export const resultFileDict = new Dict({
  COMMAND: { value: 1, label: '采购需求' },
  PLAN: { value: 2, label: '采购实施计划' }
})

// 调查方式数据字典
export const demandsInvestigationMethodDict = new Dict({
  CONSULT: { value: 1, label: '咨询/论证' },
  QUESTIONNAIRE: { value: 2, label: '问卷调查' },
  NOT_INVESTIGATION: { value: 3, label: '不调查' }
})

// 问卷调查方式
export const questionnaireMethodDict = new Dict({
  ONLINE: { value: 1, label: '线上问卷调查' },
  OFFLINE: { value: 2, label: '线下问卷调查' }
})

// 响应式输入类型字典
export const textInputTypeDict = new Dict({
  TEXTAREA: { value: 1, label: '文本域', alias: 'textarea' },
  TEXT: { value: 2, label: '文本框', alias: 'text' },
  UPLOAD_FILE_ID: { value: 3, label: '单文件上传', alias: 'groupId' }
})

// 线上问卷调查
export const onlineRequestMesDict = new Dict({
  GENERAL_INFO: {
    value: 'GENERAL_INFO',
    label: '总体信息',
    children: [
      {
        value: 'GENERAL_INFO_001',
        label: '相关产业发展及市场供给情况',
        inputType: textInputTypeDict.TEXTAREA.value,
        itemHidden: {}
      },
      {
        value: 'GENERAL_INFO_002',
        label: '拟供货产品（服务）在国内市场竞争情况',
        inputType: textInputTypeDict.TEXTAREA.value,
        itemHidden: {}
      },
      {
        value: 'GENERAL_INFO_003',
        label: '同类采购项目历史成交信息',
        inputType: textInputTypeDict.TEXTAREA.value,
        itemHidden: {}
      },
      {
        value: 'GENERAL_INFO_004',
        label: '后续运行维护、升级更新要求',
        inputType: textInputTypeDict.TEXTAREA.value,
        itemHidden: {}
      },
      {
        value: 'GENERAL_INFO_005',
        label: '后续备品备件、耗材采购要求',
        inputType: textInputTypeDict.TEXTAREA.value,
        itemHidden: {}
      },
      {
        value: 'GENERAL_INFO_006',
        label: '其他相关情况',
        inputType: textInputTypeDict.TEXTAREA.value,
        itemHidden: {}
      }
    ]
  },
  PRICE_INFO: {
    value: 'PRICE_INFO',
    label: '价格信息',
    children: [
      {
        value: 'PRICE_INFO_001',
        label: '拟报价总价',
        inputType: textInputTypeDict.TEXTAREA.value,
        itemHidden: {}
      },
      {
        value: 'PRICE_INFO_002',
        label: '上传报价表',
        inputType: textInputTypeDict.UPLOAD_FILE_ID.value,
        itemHidden: {}
      }
    ]
  },
  BUSINESS_INFO: {
    value: 'BUSINESS_INFO',
    label: '商务信息',
    editable: true,
    children: [
      {
        value: 'BUSINESS_INFO_001',
        label: '交付（实施）的时间（期限）',
        inputType: textInputTypeDict.TEXTAREA.value,
        itemHidden: {}
      },
      {
        value: 'BUSINESS_INFO_002',
        label: '交付（实施）的地点（范围）',
        inputType: textInputTypeDict.TEXTAREA.value,
        itemHidden: {}
      },
      {
        value: 'BUSINESS_INFO_003',
        label: '付款条件（进度和方式）',
        inputType: textInputTypeDict.TEXTAREA.value,
        itemHidden: {}
      },
      {
        value: 'BUSINESS_INFO_004',
        label: '保险',
        inputType: textInputTypeDict.TEXTAREA.value,
        itemHidden: {}
      },
      {
        value: 'BUSINESS_INFO_005',
        label: '包装和运输',
        inputType: textInputTypeDict.TEXTAREA.value,
        itemHidden: {
          [projectTypeDict.SERVICE.value]: true
        }
      },
      {
        value: 'BUSINESS_INFO_006',
        label: '售后服务',
        inputType: textInputTypeDict.TEXTAREA.value,
        itemHidden: {}
      }
    ]
  },
  TECHNICAL_INFO: {
    value: 'TECHNICAL_INFO',
    label: '技术信息',
    editable: true,
    children: [
      {
        value: 'TECHNICAL_INFO_001',
        label: '性能',
        inputType: textInputTypeDict.TEXTAREA.value,
        itemHidden: {
          [projectTypeDict.SERVICE.value]: true
        }
      },
      {
        value: 'TECHNICAL_INFO_002',
        label: '材料',
        inputType: textInputTypeDict.TEXTAREA.value,
        itemHidden: {
          [projectTypeDict.SERVICE.value]: true
        }
      },
      {
        value: 'TECHNICAL_INFO_003',
        label: '结构',
        inputType: textInputTypeDict.TEXTAREA.value,
        itemHidden: {
          [projectTypeDict.SERVICE.value]: true
        }
      },
      {
        value: 'TECHNICAL_INFO_004',
        label: '外观',
        inputType: textInputTypeDict.TEXTAREA.value,
        itemHidden: {
          [projectTypeDict.SERVICE.value]: true
        }
      },
      {
        value: 'TECHNICAL_INFO_005',
        label: '安全',
        inputType: textInputTypeDict.TEXTAREA.value,
        itemHidden: {
          [projectTypeDict.SERVICE.value]: true
        }
      },
      {
        value: 'TECHNICAL_INFO_006',
        label: '服务内容',
        inputType: textInputTypeDict.TEXTAREA.value,
        itemHidden: {
          [projectTypeDict.ENGINEERING.value]: true,
          [projectTypeDict.GOODS.value]: true
        }
      },
      {
        value: 'TECHNICAL_INFO_007',
        label: '标准或规范',
        inputType: textInputTypeDict.TEXTAREA.value,
        itemHidden: {}
      }
    ]
  }
})

// 供应商响应状态
export const supplierResponseStatusDict = new Dict({
  NO_RESPONSE: { value: 0, label: '未响应', type: 'primary' },
  RESPONDED: { value: 1, label: '已响应', type: 'success' }
})

// 录入方式
export const inputMethodDict = new Dict({
  TEXT: { value: 1, label: '文本输入' },
  UPLOAD: { value: 2, label: '上传附件' }
})

// 采购需求状态
export const demandsStatusDict = new Dict({
  NOT_STARTED: {
    value: 0,
    label: '未发布',
    type: 'info',
    permission: ['edit', 'delete']
  },
  FILED: {
    value: 1,
    label: '项目建档',
    type: 'primary',
    permission: ['detail'],
    routerName: 'DemandSurvey'
  },
  DEMANDS_SURVEY: {
    value: 2,
    label: '需求调查',
    type: 'warning',
    permission: ['detail'],
    routerName: 'DemandSurvey'
  },
  ACCEPT_RESPONSE: {
    value: 3,
    label: '接受调查中',
    type: 'primary',
    permission: ['detail'],
    routerName: 'DemandSignUpList'
  },
  CUT_OFF_RESPONSE: {
    value: 4,
    label: '调查已截止',
    type: 'danger',
    permission: ['detail'],
    routerName: 'DemandEntry'
  },
  ENTERED: {
    value: 5,
    label: '已录入',
    type: 'success',
    permission: ['detail'],
    routerName: 'DemandEntry'
  }
})

// 竞争范围
export const competeScopeDict = new Dict({
  OPEN: { value: 1, label: '公开竞争' },
  LIMIT: { value: 2, label: '有限竞争' },
  SINGLE: { value: 3, label: '单一供应商' }
})

// 采购组织形式
export const purchaseOrgMethodDict = new Dict({
  DISPERSED: { value: 1, label: '分散' },
  FOCUS: { value: 2, label: '集中' }
})

// 合同分包类型
export const contractSubTypeDict = new Dict({
  YES: { value: 1, label: '允许分包' },
  NO: { value: 2, label: '不允许分包' }
})

// 评审规则
export const judgingRuleMethodDict = new Dict({
  COMPREHENSIVE: { value: 1, label: '综合评价法' },
  MINIMUM_PRICE: { value: 2, label: '最低价法' }
})

// 合同类型
export const beContractTypeDict = new Dict({
  BUSINESS: { value: 1, label: '买卖合同' },
  CONSTRUCTION: { value: 2, label: '建设工程合同' },
  PROPERTY_SERVICE: { value: 3, label: '物业服务合同' },
  TECHNOLOGY: { value: 4, label: '技术合同' },
  SUPPLY: { value: 5, label: '供用电、水、气、热力合同' },
  TENANCY: { value: 6, label: '租赁合同' },
  FINANCE_LEASE: { value: 7, label: '融资租赁合同' },
  CARRIAGE: { value: 8, label: '运输合同' },
  CUSTODY: { value: 9, label: '保管合同' },
  WAREHOUSING: { value: 10, label: '仓储合同' },
  ENTRUSTMENT: { value: 11, label: '委托合同' }
})

// 定价方式
export const pricingMethodDict = new Dict({
  FIXED_TOTAL: { value: 1, label: '固定总价' },
  FIXED_UNIT: { value: 2, label: '固定单价' },
  COST_COMPENSATION: { value: 3, label: '成本补偿' },
  PERFORMANCE_INCENTIVE: { value: 4, label: '绩效激励' }
})

// 成果文件上传失败
export const uploadStatusDict = new Dict({
  INIT: { value: 0, label: '初始化' },
  UPLOADING: { value: 1, label: '上传中' },
  SUCCESS: { value: 2, label: '已上传' },
  FAIL: { value: 3, label: '上传失败' }
})

// 供应商需求调查状态
export const demandParticipateDict = new Dict({
  ALL: { value: '0', label: '全部' },
  DOING: { value: '1', label: '待响应', type: 'primary' },
  PASS: { value: '2', label: '已响应', type: 'success' },
  AUDIT: { value: '3', label: '待审核', type: 'primary' },
  FAIL: { value: '4', label: '未通过', type: 'danger' }
})
